import React from 'react'
import styled from 'styled-components/macro'

/** Why? / How? / Show me / Help me / Do it for me on a finding thread. */
const OllieFindingChips = ({
  chips = [],
  onSelect,
  disabled = false,
  askDisabled = false,
}) => {
  if (!chips.length) return null
  return (
    <Row role='group' aria-label='Follow-ups'>
      {chips.map(chip => (
        <Chip
          key={chip.id}
          type='button'
          disabled={disabled || (askDisabled && chip.kind === 'ask')}
          $action={chip.kind === 'action'}
          onClick={() => onSelect(chip)}
        >
          {chip.label}
        </Chip>
      ))}
    </Row>
  )
}

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`

const Chip = styled.button`
  border: 1px solid
    ${({ theme, $action }) =>
      $action ? theme.colours.lettuceGreen : theme.colours.panSilver};
  background: ${({ theme }) => theme.colours.mayoWhite};
  color: ${({ theme }) => theme.colours.bbqBlack};
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colours.lettuceGreen};
    background: ${({ theme }) => theme.colours.bgGrey};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`

export default OllieFindingChips
